<div>
  <div class="message-box">
    <span  class="font-size-09">{{message.sender}}</span>
    <img  (click)="photoClick.emit(message.photoUrl)" class="photo-message" *ngIf="message.photoUrl" src="{{message.photoUrl}}" alt="">
    <p class="font-size-09 mb-0 mt-1" [class.font-weight-bold]="!message.isRead">{{message.value}}</p>
  </div>
</div>

